module.exports = __webpack_public_path__ + "static/media/About_Img_1.b6387e66.png";